import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { LogsDashboard } from '../../components/Logs/LogsDashboard';

const useStyles = makeStyles({
  container: {
    padding: '24px',
  },
});

export const LogsPage: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <LogsDashboard />
    </div>
  );
};

export default LogsPage;
